import { render } from "./WidgetListTitle.vue?vue&type=template&id=52024bdf&scoped=true"
import script from "./WidgetListTitle.vue?vue&type=script&lang=js"
export * from "./WidgetListTitle.vue?vue&type=script&lang=js"

import "./WidgetListTitle.vue?vue&type=style&index=0&id=52024bdf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52024bdf"]])

export default __exports__